/**
 * src/components/header/NavCTA.js
 *
 * Botón de llamada a la acción del header.
 * Props: { label, href, icon? }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

define('NavCTA', ({ label, href, icon }) => {
    const isExternal = href && href.startsWith('http')
    const btn = h('a', { className: 'nav-cta', href, ...(isExternal ? { target: '_blank', rel: 'noopener' } : {}) })

    if (icon) btn.appendChild(h('span', { className: 'nav-cta__icon', innerHTML: icon }))
    btn.appendChild(document.createTextNode(label))

    return btn
})
